// Header + footer that mirror authorrowancain.com so the Inkshroud page
// feels like a seamless part of the author's site.
//
// NOTE: confirm/adjust these link targets to match your real page URLs.
const SITE = "https://authorrowancain.com";
const NAV_LEFT = [
  { label: "Home", href: `${SITE}/` },
  { label: "About", href: `${SITE}/about` },
  { label: "Work in Progress", href: `${SITE}/work-in-progress` },
];
const NAV_RIGHT = [
  { label: "Social Media", href: `${SITE}/social-media` },
  { label: "Contact", href: `${SITE}/contact` },
  { label: "Inkshroud", href: "/", current: true },
];

const NavLink = ({ item, testid }) => (
  <a
    href={item.href}
    data-testid={testid}
    className={`font-cinzel text-xs sm:text-[13px] uppercase tracking-[0.18em] transition-colors duration-300 whitespace-nowrap ${
      item.current
        ? "text-[#E6E2D6] border-b border-[#70250a] pb-1"
        : "text-[#E6E2D6]/70 hover:text-[#E6E2D6]"
    }`}
  >
    {item.label}
  </a>
);

const Logo = () => (
  <a href={`${SITE}/`} data-testid="site-logo" className="flex items-center justify-center shrink-0 group">
    <img
      src="/Banner.png"
      alt="Rowan Cain"
      className="h-10 sm:h-12 md:h-14 w-auto object-contain transition-opacity duration-300 group-hover:opacity-90"
    />
  </a>
);

export const SiteHeader = () => (
  <header className="sticky top-0 z-50 bg-[#041b24]/95 backdrop-blur-md border-b border-[#485354]/25" data-testid="site-header">
    <div className="max-w-6xl mx-auto px-6 h-[76px] grid grid-cols-1 md:grid-cols-3 items-center">
      <nav className="hidden md:flex items-center gap-7 justify-start min-w-0">
        {NAV_LEFT.map((i) => <NavLink key={i.label} item={i} testid={`nav-${i.label.toLowerCase().replace(/ /g, "-")}`} />)}
      </nav>
      <div className="flex justify-center">
        <Logo />
      </div>
      <nav className="hidden md:flex items-center gap-5 sm:gap-7 justify-end min-w-0">
        {NAV_RIGHT.map((i) => <NavLink key={i.label} item={i} testid={`nav-${i.label.toLowerCase().replace(/ /g, "-")}`} />)}
      </nav>
    </div>
  </header>
);

export const SiteFooter = () => (
  <footer className="relative border-t border-[#485354]/30 bg-[#020f14]" data-testid="site-footer">
    <div className="max-w-6xl mx-auto px-6 py-12">
      <div className="flex flex-col items-center gap-6 text-center">
        <a href={`${SITE}/`} className="font-cinzel text-lg tracking-[0.2em] text-[#E6E2D6] uppercase" data-testid="footer-logo">Rowan Cain</a>
        <nav className="flex flex-wrap items-center justify-center gap-x-7 gap-y-3">
          {[...NAV_LEFT, ...NAV_RIGHT].map((i) => (
            <a key={i.label} href={i.href} className="font-cinzel text-[11px] uppercase tracking-[0.18em] text-[#E6E2D6]/60 hover:text-[#E6E2D6] transition-colors">
              {i.label}
            </a>
          ))}
        </nav>
        <a
          href={`${SITE}/`}
          data-testid="footer-back"
          className="font-mono text-[11px] uppercase tracking-widest text-[#70250a] hover:text-[#8A2E0D] transition-colors"
        >
          ← Back to authorrowancain.com
        </a>
        <p className="font-mono text-[11px] uppercase tracking-widest text-[#485354]">
          © {new Date().getFullYear()} Rowan Cain · Inkshroud
        </p>
      </div>
    </div>
  </footer>
);
